import script from "./BindBankCardRule.vue?vue&type=script&lang=ts&setup=true"
export * from "./BindBankCardRule.vue?vue&type=script&lang=ts&setup=true"

import "./BindBankCardRule.vue?vue&type=style&index=0&id=7ed767fa&lang=css"
import "./BindBankCardRule.vue?vue&type=style&index=1&id=7ed767fa&scoped=true&lang=css"

import exportComponent from "/Users/carl/project/meta/landings/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed767fa"]])

export default __exports__